export default __webpack_public_path__ + "static/media/avatar_cheshire_cat7.2ad194c0.mp3";